"use client";

import { Suspense } from "react";
import {
  TrackPageContent,
  TrackPageFallback,
} from "@/components/pages/TrackPageContent";

export default function TrackOrderPage() {
  return (
    <Suspense fallback={<TrackPageFallback />}>
      <TrackPageContent />
    </Suspense>
  );
}
